import useApi from "@/services/useApi";
import { showToast } from "@/helpers/showToast"

const defaultState = () => {
    return {
        updatePasswordLoading: false,
        updateInfoLoading: false,
        userData: null
    }
}

const userModule = {
    namespaced: true,
    state: defaultState(),
    getters: {
        getPasswordLoading: (state) => {
            return state.updatePasswordLoading
        },
        getInfoLoading: (state) => {
            return state.updateInfoLoading
        },
        getCurrentUserData: (state) => {
            return state.userData
        },
        isUserHasNumbers: (state) => {
            return !!state.userData?.count_numbers ?? false
        }
    },
    mutations: {
        SET_PASSWORD_LOADING(state, loading) {
            state.updatePasswordLoading = loading
        },
        SET_INFO_LOADING(state, loading) {
            state.updateInfoLoading = loading
        },
        SET_USER_DATA(state, data) {
            state.userData = data
        },
        SET_USER_DATA_TO_LOCAL_STORAGE(_, data) {
            localStorage.setItem('user-data', JSON.stringify(data))
        }
    },
    actions: {
        async getCurrentUserInfo({commit}) {
            const { api, reactiveHeaders } = useApi();

            try {
                const { data } = await api.get('/api/me', { headers: reactiveHeaders.value })
                commit('SET_USER_DATA', data.data)
                commit('SET_USER_DATA_TO_LOCAL_STORAGE', data.data)
            } catch (error) {
                throw error
            }
        },
        async updateUserPassword({ commit }, { payload, moshaToast }) {
            const { api, reactiveHeaders } = useApi();

            commit('SET_PASSWORD_LOADING', true);

            try {
                const { data } = await api.put(
                    '/api/account/password',
                    payload,
                    { headers: reactiveHeaders.value }
                )
                showToast(moshaToast, 'success', data.description)
            } catch (error) {
                showToast(moshaToast, 'error', error?.response?.data?.description || 'Something went wrong')
            } finally {
                commit('SET_PASSWORD_LOADING', false);
            }
        },
        async updateUserInfo({commit}, {payload, moshaToast}) {
            const { api, reactiveHeaders } = useApi();

            commit('SET_INFO_LOADING', true)

            try {
                const {data} = await api.put('/api/account', payload, {headers: reactiveHeaders.value})
                showToast(moshaToast, 'success', data.description)
                commit('SET_USER_DATA', data.data)
                commit('SET_USER_DATA_TO_LOCAL_STORAGE', data.data)
            } catch (error) {
                showToast(moshaToast, 'error', error?.response?.data?.description || 'Something went wrong')
            } finally {
                commit('SET_INFO_LOADING', false)
            }
        }
    }
}

export default userModule
